import React, { useEffect, useState, useContext } from 'react';
import { Header, Icon, Container, Card, Button, Message } from 'semantic-ui-react'
import { MdDoNotDisturbOff } from 'react-icons/md';
import { ConnectWS } from '../../../../ConnectWS';
import AuthContext from '../../../../context/authContext';

function BuyAdsOff(props) {
  const [form, setForm] = useState(null);
  const [message, setMessage] = useState(null);
  const authContext = useContext(AuthContext);


  function generateHotPayDataRemoveGoogleAds (tournament_id) {
    ConnectWS("/payment/generateHotPayDataRemoveGoogleAds", authContext.token, { tournament_id: tournament_id }, function (response, logout) {

      if (logout === 1) {
        setMessage(response.data)
        setForm(null)
      } else if (response && response.status && Number(response.status) === 200) {
        //setRowDataTournament(response.data)
        setForm(response.data)
        document.getElementById("orderHP").submit();
        setMessage(null)
      } else {

        console.log(response);
        setForm(null)
        setMessage(response)
      }

    });
  }


  useEffect(() => {
    return () => { }; // use effect cleanup to set flag false, if unmounted
  }, [])// eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Container textAlign='center'>
      <Header as='h3' icon>

        <span style={{ fontSize: 16, color: "#c33c3c", margin: 0, padding: 0, }} ><Icon name="adversal"/>
        </span>
       Wyłacz reklamy Google dla turnieju:
        <Header.Subheader>
          {props.tournament_name}
        </Header.Subheader>
      </Header>
      <br />
      <p>
        <i>Wyłączając reklamy zyskujesz pełną czytelność strony oraz - <strong>co najważniejsze</strong> - umożliwiasz nam dalszy rozwój oprogramowania</i>
      </p>
      {message ? <Message negative>
        <Message.Header>ERROR</Message.Header>
        <p>{message}</p>
      </Message> : ""}
      <Card.Group centered>

        <Card link color='red' onClick={() => generateHotPayDataRemoveGoogleAds(props.tournament_id)}>
          <Card.Content className='ContentCenter'>
            <span style={{ fontSize: 35, margin: 0, padding: 0, }} className='ContentCenterIcon1AD'>
            <Icon.Group >
      <Icon size='big' color='red' name='dont' />
      <Icon  name='adversal' />
    </Icon.Group>
            </span>
            <Card.Header>REKLAMA GOOGLE</Card.Header>
            <Card.Meta style={{ fontSize: 12 }}><Icon name="credit card" /> PŁATNOŚĆ BLIK LUB ONLINE</Card.Meta>
            <Card.Meta style={{ fontSize: 12 }}><MdDoNotDisturbOff /> BEZ REJESTRACJI</Card.Meta>
          </Card.Content>
          <Card.Content extra>
            <Button basic color='red'>
              <b>WYŁĄCZ REKLAMY 2 PLN</b>
            </Button>
          </Card.Content>
        </Card>

      
      </Card.Group>


      {form ?
        <form style={{ display: "none" }}
          id="orderHP"
          action="https://platnosc.hotpay.pl/"
          method="post">
          <input required name="SEKRET" value={form.SEKRET} type="hidden" />
          <input required name="HASH" value={form.HASH} type="hidden" />
          <input required name="KWOTA" value={form.KWOTA} type="hidden" />
          <input required name="NAZWA_USLUGI" value={form.NAZWA_USLUGI} type="hidden" />
          <input required name="ADRES_WWW" value={form.ADRES_WWW} type="hidden" />
          <input required name="ID_ZAMOWIENIA" value={form.ID_ZAMOWIENIA} type="hidden" />
          <input name="EMAIL" value={form.EMAIL} type="hidden" />
          <input name="DANE_OSOBOWE" value={form.DANE_OSOBOWE} type="hidden" />
          <button type="submit">Submit</button>
        </form>
        : ""}
    </Container>

  )
}

export default BuyAdsOff;